// ❌ Removed TypeScript type import
// import { DataRow } from "../components/PrebidAds/DataTable";

export const partnerData = [
  {
    id: "1",
    name: "Partner Alpha",
    impressions: 1250000,
    clicks: 45000,
    ctr: 3.6,
    conversions: 2250,
    revenue: 112500,
    spend: 35000,
    roas: 3.21,
  },
  {
    id: "2",
    name: "Partner Beta",
    impressions: 980000,
    clicks: 32000,
    ctr: 3.27,
    conversions: 1600,
    revenue: 80000,
    spend: 28000,
    roas: 2.86,
  },
  {
    id: "3",
    name: "Partner Gamma",
    impressions: 2100000,
    clicks: 78000,
    ctr: 3.71,
    conversions: 3900,
    revenue: 195000,
    spend: 52000,
    roas: 3.75,
  },
  {
    id: "4",
    name: "Partner Delta",
    impressions: 560000,
    clicks: 18000,
    ctr: 3.21,
    conversions: 720,
    revenue: 36000,
    spend: 15000,
    roas: 2.4,
  },
  {
    id: "5",
    name: "Partner Epsilon",
    impressions: 1800000,
    clicks: 62000,
    ctr: 3.44,
    conversions: 2480,
    revenue: 124000,
    spend: 42000,
    roas: 2.95,
  },
];

export const operWarpData = [
  {
    id: "1",
    name: "Campaign Omega",
    impressions: 3200000,
    clicks: 128000,
    ctr: 4.0,
    conversions: 6400,
    revenue: 320000,
    spend: 85000,
    roas: 3.76,
  },
  {
    id: "2",
    name: "Campaign Nova",
    impressions: 1500000,
    clicks: 52500,
    ctr: 3.5,
    conversions: 2100,
    revenue: 105000,
    spend: 38000,
    roas: 2.76,
  },
  {
    id: "3",
    name: "Campaign Pulse",
    impressions: 890000,
    clicks: 31150,
    ctr: 3.5,
    conversions: 1246,
    revenue: 62300,
    spend: 24000,
    roas: 2.6,
  },
  {
    id: "4",
    name: "Campaign Flux",
    impressions: 2400000,
    clicks: 96000,
    ctr: 4.0,
    conversions: 4800,
    revenue: 240000,
    spend: 62000,
    roas: 3.87,
  },
  {
    id: "5",
    name: "Campaign Vortex",
    impressions: 1100000,
    clicks: 38500,
    ctr: 3.5,
    conversions: 1540,
    revenue: 77000,
    spend: 32000,
    roas: 2.41,
  },
];

export const calculateTotals = (data) => {
  return data.reduce(
    (acc, row) => ({
      impressions: acc.impressions + row.impressions,
      clicks: acc.clicks + row.clicks,
      conversions: acc.conversions + row.conversions,
      revenue: acc.revenue + row.revenue,
      spend: acc.spend + row.spend,
    }),
    {
      impressions: 0,
      clicks: 0,
      conversions: 0,
      revenue: 0,
      spend: 0,
    }
  );
};
